<script>
import WishlistButton from '@phoenix/mixins/components/wishlist/WishlistButton';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [WishlistButton],

  props: {
    iconSize: {
      type: String,
      default: '16',
    },
    defaultInWishlistIcon: {
      type: String,
      default: 'heart-full',
    },
    buttonClasses: {
      type: Array,
      default: () => ['btn', 'btn--default', 'btn--xs', 'btn--icon-only', 'btn--icon', 'btn--transparent'],
    },
    iconClasses: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      defaultIcon: 'heart',
    };
  },

  computed: {
    iconWithSize() {
      return `${this.icon}-${this.iconSize}`;
    },
  },
};
</script>

<template>
  <button
    :class="buttonClasses"
    :aria-label="ariaLabel"
    :data-cy="dataCy"
    :data-tracking="trackingDatalayer"
    @click.prevent="toggleProduct({ reference, showBanner })"
  >
    <span class="btn__icon">
      <phx-icon :key="iconWithSize" :icon="iconWithSize" :size="iconSize" :class="iconClasses" />
    </span>
  </button>
</template>
